import { v4 as uuidv4 } from 'uuid';
import { EVENTS } from './event-list';
import { selectors, store } from '../user-area/redux/store';
import { UTMController } from '../common/controllers/utm-controller';
import { getCookie, setCookie } from '../utils/cookies';

const EVENT_ATTRIBUTE = 'data-track-click';
const TRACKER_ENDPOINT = '/api/events/index.php';
const TRACK_ACTION = 'register-event';

let lastEventValue: string | null = null;
let lastEventTime: number = 0;
const THROTTLE_DELAY = 3000;

// Track elements that already have listeners to prevent duplicates
const elementsWithListeners = new WeakSet();

// Inicialize the UTM Controller
const utmController = new UTMController();

const getLoggedOutUUID = () => {
    if (!getCookie('sessionUUIDtm')) {
        const sessionUUIDtm = getCookie('sessionUUIDtm');
        if (!sessionUUIDtm) {
            const sessionUUIDtm = uuidv4();
            setCookie('sessionUUIDtm', sessionUUIDtm);
        }
        return sessionUUIDtm;
    }
    return getCookie('sessionUUIDtm');
};

const getDeviceType = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i)) {
        return 'mobile';
    } else if (userAgent.match(/iPad/i) || userAgent.match(/Tablet/i)) {
        return 'tablet';
    } else {
        return 'desktop';
    }
};

const getUtmSource = () => {
    const utmSource = utmController.getUTMSource();
    return utmSource || '';
};

export const trackClickEventHandler = (event: Event) => {
    const target = event.target as HTMLElement;

    // Find the element with data-track-click attribute (could be the target or its ancestor)
    const elementWithAttribute = target.closest(`[${EVENT_ATTRIBUTE}]`);

    if (!elementWithAttribute) {
        return;
    }

    const eventValue = elementWithAttribute.getAttribute(EVENT_ATTRIBUTE);
    trackClickEvent(eventValue as keyof typeof EVENTS);
};

const setupListeners = () => {
    getLoggedOutUUID();
    const elementsToTrack = document.querySelectorAll(`[${EVENT_ATTRIBUTE}]`);
    elementsToTrack.forEach((element) => {
        // Only add listener if this element doesn't already have one
        if (!elementsWithListeners.has(element)) {
            element.addEventListener('click', trackClickEventHandler);
            elementsWithListeners.add(element);
        }
    });
};

export const trackClickEvent = (eventValue: keyof typeof EVENTS) => {
    if (!eventValue || !EVENTS[eventValue]) {
        return;
    }

    const currentTime = Date.now();
    if (eventValue === lastEventValue && currentTime - lastEventTime < THROTTLE_DELAY) {
        return;
    }

    const { uuid: user_id } = selectors.auth.credentials(store.getState().auth);

    const data = {
        action: TRACK_ACTION,
        event_type_id: EVENTS[eventValue],
        uuid: getLoggedOutUUID(),
        user_uuid: user_id,
        url: window.location.pathname,
        device: getDeviceType(),
        referer: document.referrer,
        sourceUrl: getUtmSource(),
    };

    const payload = JSON.stringify(data);
    navigator.sendBeacon(TRACKER_ENDPOINT, payload);

    lastEventValue = eventValue;
    lastEventTime = currentTime;
};

window.addEventListener('DOMContentLoaded', setupListeners);
window.addEventListener('data-track-event-added', setupListeners);
